import { render, staticRenderFns } from "./EcommerceList.vue?vue&type=template&id=53d33fc0&"
import script from "./EcommerceList.vue?vue&type=script&lang=js&"
export * from "./EcommerceList.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceList.vue?vue&type=style&index=0&id=53d33fc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports